import { MarkdownShortcutPlugin as LexicalMarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin'
import React, { FC } from 'react'

import { ALL_TRANSFORMERS } from '../MarkdownTransformers'

/**
 * Shortcut plugin from lexical library with our custom transformers
 */
export const MarkdownShortcutPlugin: FC = () => {
  return <LexicalMarkdownShortcutPlugin transformers={ALL_TRANSFORMERS} />
}
